import format from "date-fns/format";
import { useFormikContext } from "formik";
import { Col, Row } from "react-bootstrap";
import { UtilisateurFiltrageEntity } from "../../Entities/UtilisateurEntity.tsx";
import { MinimalRessourceEntity } from "../../Entities/RessourceEntity.tsx";
import { RoleEntity } from "../../Entities/RoleEntity.tsx";
import { useGet } from "../../components/Fetch/useFetch.tsx";
import Accordion from "../../components/Accordion/Accordion.tsx";
import DateSelect from "../../components/Date/DateSelect.tsx";
import url from "../../module/fetch.tsx";
import Filter, {
  FilterNumber,
  FilterText,
} from "../../components/Filter/Filter.tsx";
import Button, {
  LinkButton,
  TYPE_BUTTON,
} from "../../components/Button/Button.tsx";
import { IconFileExport } from "../../components/Icon/Icon.tsx";
import { MultiSelectInput } from "../../components/Form/Form.tsx";
type filterByType = {
  utilisateurUsername?: string;
  utilisateursIds?: string[];
  rolesIds?: string[];
  dateDebut?: Date;
  dateFin?: Date;
  dureeMin?: number;
  dureeMax?: number;
  ressourcesConsulteesCodes?: string[];
};

type sortByType = {
  utilisateurUsername?: number;
  connexionDate?: number;
  deconnexionDate?: number;
  duree?: number;
};

type filterLogConnexion = {
  utilisateurUsername?: string;
  utilisateurs?: UtilisateurFiltrageEntity[];
  utilisateursIds?: string[];
  roles?: RoleEntity[];
  rolesIds?: string[];
  dateDebut?: Date;
  dateFin?: Date;
  dureeMin?: number;
  dureeMax?: number;
  ressourcesConsultees?: MinimalRessourceEntity[];
  ressourcesConsulteesCodes?: string[];
};

export const initialFilterValues = {
  utilisateurUsername: "",
  utilisateursIds: null,
  rolesIds: null,
  dateDebut: null,
  dateFin: null,
  dureeMin: null,
  dureeMax: null,
  ressourcesConsulteesCodes: null,
};

export const filterValuesToVariable = ({
  utilisateurUsername,
  utilisateurs,
  roles,
  dateDebut,
  dateFin,
  dureeMin,
  dureeMax,
  ressourcesConsultees,
}: filterLogConnexion) => {
  const filter: filterLogConnexion = {};

  if (utilisateurUsername != null && utilisateurUsername.trim() !== "") {
    filter.utilisateurUsername = utilisateurUsername;
  }

  if (utilisateurs != null && utilisateurs.length > 0) {
    filter.utilisateursIds = utilisateurs.map(
      (e: UtilisateurFiltrageEntity) => e.utilisateurId,
    );
  }

  if (roles != null && roles.length > 0) {
    filter.rolesIds = roles.map((e: RoleEntity) => e.roleId);
  }

  if (dateDebut != null) {
    filter.dateDebut = format(new Date(dateDebut), "yyyy-MM-dd");
  }

  if (dateFin != null) {
    filter.dateFin = format(new Date(dateFin), "yyyy-MM-dd");
  }

  if (dureeMin != null && dureeMin !== "") {
    filter.dureeMin = dureeMin;
  }

  if (dureeMax != null && dureeMax !== "") {
    filter.dureeMax = dureeMax;
  }

  if (ressourcesConsultees != null && ressourcesConsultees.length > 0) {
    filter.ressourcesConsulteesCodes = ressourcesConsultees.map(
      (e: MinimalRessourceEntity) => e.ressourceCode,
    );
  }

  return filter;
};

const FilterLogConnexion = ({
  filterBy,
  sortBy,
}: {
  filterBy: filterByType;
  sortBy: sortByType;
}) => {
  const stateListUtilisateur = useGet(url`/api/utilisateurs/getAll`);
  const stateListRole = useGet(url`/api/roles/`);
  const stateListRessources = useGet(
    url`/api/ressource/getAllRessourcesToFilter`,
  );

  const { setFieldValue, values, setValues } = useFormikContext();

  return (
    <Filter>
      <Row>
        <Col xs={6}>
          <FilterText
            label=""
            aria-labelledby="recherche-utilisateur"
            placeholder="Recherche un utilisateur"
            name="utilisateurUsername"
            submitable={true}
          />
          <p id="recherche-utilisateur" className={"d-none"}>
            Rechercher un utilisateur
          </p>
        </Col>
        <Col
          xs={6}
          className={"text-center d-flex flex-column justify-content-center"}
        >
          <LinkButton
            href={url`/api/exportLogConnexion/export-csv?${{
              // filterBy
              utilisateurUsername: filterBy.utilisateurUsername,
              utilisateursIds: filterBy.utilisateursIds,
              rolesIds: filterBy.rolesIds,
              dateDebut: filterBy.dateDebut,
              dateFin: filterBy.dateFin,
              dureeMin: filterBy.dureeMin,
              dureeMax: filterBy.dureeMax,
              ressourcesConsulteesCodes: filterBy.ressourcesConsulteesCodes,
              // sortBy
              utilisateurIdsSort: sortBy.utilisateurUsername,
              connexionDate: sortBy.connexionDate,
              deconnexionDate: sortBy.deconnexionDate,
              duree: sortBy.duree,
            }}`}
            className={"text-center mx-auto"}
          >
            Tout exporter&nbsp;
            <IconFileExport />
          </LinkButton>
        </Col>
        <Col className={"mb-3 text-center"}>
          <Accordion
            title={"Filtrer les données"}
            content={
              <Row>
                <Col>
                  <p id="filter-identifiant-user">Identifiant</p>
                  <MultiSelectInput
                    label=""
                    aria-labelledby="filter-identifiant-user"
                    name="utilisateurs"
                    placeholder="Tous"
                    options={stateListUtilisateur.value}
                    getOptionValue={(u: UtilisateurFiltrageEntity) =>
                      u.utilisateurId
                    }
                    toOptionLabelFunc={(u: UtilisateurFiltrageEntity) =>
                      u.utilisateurUsername
                    }
                    isClearable
                  />
                </Col>
                <Col>
                  <p id="filter-roles">Rôles</p>
                  <MultiSelectInput
                    label=""
                    aria-labelledby="filter-roles"
                    name="roles"
                    placeholder="Tous"
                    options={stateListRole.value}
                    getOptionValue={(u: RoleEntity) => u.roleId}
                    toOptionLabelFunc={(u: RoleEntity) => u.roleLibelle}
                    isClearable
                  />
                </Col>
                <Row>
                  <p>Date des événements</p>
                </Row>
                <Row>
                  <Col>
                    <p id="filter-date-debut">Date de début des évenements</p>
                    <DateSelect
                      aria-labelledby="filter-date-debut"
                      onChangeHandler={(date) =>
                        setFieldValue("dateDebut", date)
                      }
                      startDate={
                        values?.dateDebut ? new Date(values.dateDebut) : null
                      }
                      selectsRange={false}
                      maxDate={values?.dateFin ?? undefined}
                      defaultMessage="A partir du ..."
                    />
                  </Col>
                  <Col>
                    <p id="filter-date-fin">Date de fin des évenements</p>
                    <DateSelect
                      aria-labelledby="filter-date-fin"
                      onChangeHandler={(date) => setFieldValue("dateFin", date)}
                      startDate={
                        values?.dateFin ? new Date(values.dateFin) : null
                      }
                      selectsRange={false}
                      minDate={values?.dateDebut ?? undefined}
                      defaultMessage="Jusqu'à ..."
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <p id="filter-duree">Durée (en minutes)</p>
                  </Col>
                  <Col>
                    <p id="filter-duree-min">
                      Durée minimum d&apos;une session en minutes
                    </p>
                    <FilterNumber
                      aria-labelledby="filter-duree-min"
                      name="dureeMin"
                      min={0}
                      placeholder="Min"
                      disabled={false}
                      onBlur={(value) => {
                        const valeur = value.target.value;
                        if (
                          valeur &&
                          values.dureeMax &&
                          values.dureeMax < valeur
                        ) {
                          setValues({
                            ...values,
                            dureeMin: values.dureeMax,
                          });
                        }
                      }}
                    />
                  </Col>
                  <Col>
                    <p id="filter-duree-max">
                      Durée maximum d&apos;une session en minutes
                    </p>
                    <FilterNumber
                      aria-labelledby="filter-duree-max"
                      name="dureeMax"
                      min={1}
                      placeholder="Max"
                      disabled={false}
                      onBlur={(value) => {
                        const valeur = value.target.value;
                        if (
                          valeur &&
                          values.dureeMin &&
                          values.dureeMin > valeur
                        ) {
                          setValues({
                            ...values,
                            dureeMax: values.dureeMin,
                          });
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p id="filter-ressources-consultees">
                      Ressources consultées
                    </p>
                    <MultiSelectInput
                      label=""
                      aria-labelledby="filter-ressources-consultees"
                      name="ressourcesConsultees"
                      placeholder="Toutes"
                      options={stateListRessources.value}
                      getOptionValue={(u: MinimalRessourceEntity) =>
                        u.ressourceCode
                      }
                      toOptionLabelFunc={(u: MinimalRessourceEntity) =>
                        u.ressourceLibelle
                      }
                      isClearable
                    />
                  </Col>
                </Row>
                <Col xs={"auto"} className={"mx-auto"}>
                  <Button type={TYPE_BUTTON.submit} className={"text-center"}>
                    Valider les filtres
                  </Button>
                </Col>
              </Row>
            }
          />
        </Col>
      </Row>
    </Filter>
  );
};

export default FilterLogConnexion;
